import React, { useEffect, useState } from "react";

import Loader from "../Loader";
import Footer_en from "./Footer_en";
import Header_en from "./Header_en";

const Durabilite_en = () => {
      const [isVisible, setIsVisible] = useState(false);
      useEffect(() => {
        // Delay the visibility of the component
        const timer = setTimeout(() => {
          setIsVisible(true); // Set to visible after the delay
        }, 200);
    
        return () => clearTimeout(timer); // Clean up on unmount
      }, []);
  return (
     <div>
      <div>
        <Header_en />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        <section
          className="page-title bg-overlay-black-60 parallax"
          data-jarallax='{"speed": 0.6}'
          style={{
            backgroundImage: "url(/assets/images/RSE/background.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name" style={{ width: "80%" }}>
                  <h1>Building a sustainable future</h1>
                  <p style={{textTransform:"none"}}>
                    SACEM Industries is committed to placing
                    environmental, social and governance values at the heart of its
                    industrial strategy, with a view to responsible development that
                    benefits its employees, customers and the community.
                  </p>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/">
                      <i className="fa fa-home" /> Accueil
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>Sustainability</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section >
          <section
            className="action-box theme-bg full-width "
            style={{
              background: "#FFFFFF",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <img
                    className="img-fluid full-width mb-20"
                    src="/assets/images/RSE/PacteMondiale_en.jpg"
                    alt="Responsabilité Sociétale SACEM"
                  />
                </div>
                <div className="col-lg-4 col-md-4">
                  {/**col-lg-6 col-md- */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <p
                      style={{
                        color: "#9CA2AC",
                        textAlign: "center",
                      }}
                    >
                      Active commitment to the Ten Principles in the
                      areas of human rights, labour,
                      the environment and the fight against corruption.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <p
                      style={{
                        color: "#9CA2AC",
                        textAlign: "end",
                        fontSize: "12px",
                      }}
                    >
                      Reporting period: January – December 2025
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section style={{background:"#f7f7f7"}}>
            <div className="container">
              <div className="row" style={{paddingTop:"10px"}}>
                <div className="col-md-8">
                  <div className="section-title">
                    <h2 className="title-effect">
                      Statement by the CEO
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div
                    className="owl-carousel"
                    data-nav-arrow="false"
                    data-nav-dots="true"
                    data-items={1}
                    data-lg-items={1}
                    data-md-items={1}
                    data-sm-items={1}
                    data-xs-items={1}
                  >
                    <div className="item">
                      <div className="testimonial bottom_pos light" style={{background:"#f7f7f7"}}>
                        <div className="testimonial-info">
                          {" "}
                          <h3
                            style={{
                              fontSize: "18px",
                              lineHeight: "20px",
                              color: "#656565",
                            }}
                          >
                            We reaffirm our support for the Ten Principles of the
                            United Nations Global Compact and our ambition to
                            make SACEM Industries a responsible and exemplary
                            industrial player.
                          </h3>
                          Our CSR approach is not merely an exercise in
                          compliance; it stems from a deep-seated conviction that
                          industrial performance and
                          environmental and social responsibility are inextricably linked.
                          Every transformer we manufacture at Tinja is
                          a reflection of this collective commitment.
                        </div>
                        <br />
                        <div>
                          {" "}
                          <strong>
                            Khaled Kammoun <br />{" "}
                            <span style={{ color: "#002f6c" }}>
                              Chief Executive Officer — SACEM Industries
                            </span>
                          </strong>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 row">
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-30 clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          0%
                        </h5>

                        <p>Gender pay gap</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-30 clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          30%
                        </h5>

                        <p>Women in leadership roles.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 sm-mb-30">
                    <div className=" clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          3091
                        </h5>

                        <p>m³ of water consumed in 2025</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className=" clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          1.75
                        </h5>

                        <p>Workplace accident rate  (‰)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="container" style={{paddingTop:"20px", paddingBottom:"10px"}}>
              <div className="row ">
                <div className="col-lg-12 col-md-12">
                  <h5 >Our Three Pillars</h5>
                  <h3 className="mb-30">
                    A structured and ambitious CSR approach
                  </h3>
                  <p>
                    Our sustainable development strategy is structured around
                    three key pillars, guided by the principles of the
                    UN Global Compact and aligned with the
                    Sustainable Development Goals.
                  </p>
                </div>
                <div className="col-lg-4 col-md-4 sm-mb-30">
                  <div className="card" style={{ height: "100%" }}>
                    <div
                      className="card-body"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "56px",
                          display: "flex",
                          borderRadius: "12px",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <h6 className="card-subtitle mb-2 text-muted">
                          Pillar 1
                        </h6>
                      </div>
                      <div style={{ width: "100%" }}>
                       <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/** <h5 className="card-title">Environnement</h5>*/} 
                          <div>
                            <img
                              src="/assets/images/RSE/Environment_en.png"
                              style={{ height: "150px", width: "150px",marginBottom:"10px" }}
                              alt
                            />
                          </div>
                        
                        </div>
                        <p className="card-text" style={{ fontSize: "14px" }}>
                          To reduce our environmental impact through
                          rigorous management of resources, waste and
                          energy at our Tinja industrial site.
                        </p>
                        <div style={{ fontSize: "12px" }}>
                          <ul className="list list list-unstyled mb-30">
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Optimising industrial waste management
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Reduction in water consumption (target: –15
                              %)
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Transition to renewable energy
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              GHG emissions measurement scheduled for late 2026
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Reducing oil leaks from transformers
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 sm-mb-30">
                  <div className="card" style={{ height: "100%" }}>
                    <div
                      className="card-body"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "56px",
                          display: "flex",
                          borderRadius: "12px",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <h6 className="card-subtitle mb-2 text-muted">
                          Pillar 2
                        </h6>
                      </div>
                      <div  style={{width: "100%"}}>
                     <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                           <div>
                            <img
                              src="/assets/images/RSE/Sacial.png"
                              style={{ height: "160px", width: "160px",marginBottom:"10px" }}
                              alt
                            />
                          </div>
                        </div>

                        <p className="card-text" style={{ fontSize: "14px" }}>
                          To value our staff and contribute to the
                          development of the local community in Tinja,
                          Tunisia and internationally.
                        </p>
                        <div style={{ fontSize: "12px" }}>
                          <ul className="list list list-unstyled mb-30">
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />0% gender pay gap
                              between women and men
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              30 per cent of women in management positions
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Refurbishment of the Tinja health centre
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Strengthening the safety culture (HSE)
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Formal alert and protection procedures
                            </li>
                          </ul>
                        </div>
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 sm-mb-30">
                  <div className="card" style={{ height: "100%" }}>
                    <div
                      className="card-body"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "56px",
                          display: "flex",
                          borderRadius: "12px",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                       <h6 className="card-subtitle mb-2 text-muted">
                            Pillar 3
                        </h6>
                      </div>
                      <div style={{ width: "100%" }}>
                       <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          
                           <div>
                            <img
                              src="/assets/images/RSE/Covernance_en.png"
                              style={{ height: "160px", width: "160px",marginBottom:"10px" }}
                              alt
                            />
                          </div>
                         
                        </div>
                        <p className="card-text" style={{ fontSize: "14px" }}>
                          To ensure ethical and transparent governance, with
                          robust mechanisms for integrity, compliance and
                          anti-corruption.
                        </p>
                        <div style={{ fontSize: "12px" }}>
                          <ul className="list list list-unstyled mb-30">
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Code of Conduct across the entire value chain
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Anti-corruption compliance programme
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Annual training for the General Counsel and Head of Human Resources
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Board of Directors: 7 members, 30 per cent
                              women
                            </li>
                            <li>
                              {" "}
                              <i className="fa fa-dot-circle-o" />
                              Confidential internal reporting channels
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section style={{background:"#f7f7f7"}}>
            <div className="container" style={{ paddingTop: "30px" }}>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <h5>
                    2025 Initiatives
                  </h5>
                  <h3
                    className="mb-30"
                   
                  >
                    Concrete actions and achievements
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="clients-box mb-30 clearfix">
                    <div
                      className="clients-photo"
                      style={{ background: "none",marginTop:"10%" }}
                    >
                      <img
                        src="/assets/images/RSE/sante.png"
                        style={{ height: "200px", width: "200px" }}
                        alt
                      />
                    </div>
                    <div className="clients-info sm-pt-20">
                      <h6 style={{ fontSize: "10px" }}> Local community</h6>
                      <h5>Refurbishment of the Tinja Health Centre</h5>

                      <p>
                        SACEM Industries funded and coordinated the
                        complete refurbishment of the Tinja health centre, improving
                        the conditions in which patients are received and the
                        working environment for medical staff. This is a project of great
                        human value that strengthens the company’s
                        roots in the local community.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="clients-box mb-30 clearfix">
                    <div
                      className="clients-photo"
                      style={{ background: "none",marginTop:"10%" }}
                    >
                      <img
                        src="/assets/images/RSE/watersave.png"
                        style={{ height: "200px", width: "200px" }}
                        alt
                      />
                    </div>
                    <div className="clients-info sm-pt-20">
                      <h6 style={{ fontSize: "10px" }}> Environment</h6>
                      <h5>Water Conservation Plan</h5>

                      <p>
                        Introduction of regular monitoring of water consumption
                        (3,091 m³ in 2025) with a view to achieving a
                        gradual reduction. Progress is reported internally at
                        the highest level of the company and incorporated into our
                        operational strategy.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="clients-box mb-30 clearfix">
                    <div
                      className="clients-photo"
                      style={{ background: "none",marginTop:"5%" }}
                    >
                      <img
                        src="/assets/images/RSE/Energy.png"
                        style={{ height: "200px", width: "200px" }}
                        alt
                      />
                    </div>
                    <div className="clients-info sm-pt-20">
                      <h6 style={{ fontSize: "10px" }}> Energy</h6>
                      <h5>Energy transition strategy</h5>

                      <p>
                        A commitment to adopting renewable energy and
                        optimising the energy footprint of our
                        production processes. A transition plan will be
                        submitted to senior management for formal approval.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="clients-box mb-30 clearfix">
                    <div
                      className="clients-photo"
                      style={{ background: "none",marginTop:"5%" }}
                    >
                      <img
                        src="/assets/images/RSE/worker-insurance.png"
                        style={{ height: "200px", width: "200px" }}
                        alt
                      />
                    </div>
                    <div className="clients-info sm-pt-20">
                      <h6 style={{ fontSize: "10px" }}>Health and safety at work</h6>
                      <h5>Strengthening the HSE culture</h5>

                      <p>
                        Continuation of the industrial risk prevention programme
                        with regular training and monitoring
                        of annual targets. Workplace accident rate:
                        1.75‰ — with a target of continuous reduction over the
                        next two years.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="container">
            <div className="row">
              <div>
                <div className="section-title" style={{ paddingTop: "10px" }}>
                  <h6>Strategic alignment</h6>
                  <h2 className="title-effect">
                    Sustainable Development Goals
                  </h2>
                  <p>
                    SACEM Industries aligns its CSR initiatives with the
                    United Nations SDGs most relevant to its
                    industrial activities and its local presence in Tunisia.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 col-md-6 mb-50 sm-mb-30">
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG3.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div
                    className="feature-info"
                    style={{ alignContent: "center" }}
                  >
                    <h5 className="text-back">Good health and wellbeing</h5>
                    <p className="mb-0">SDG3</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG5.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">Gender equality</h5>
                    <p className="mb-0">SDG5</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG6.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">Clean water and sanitation</h5>
                    <p className="mb-0">SDG6</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG7.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">
                       Affordable and clean energy
                    </h5>
                    <p className="mb-0">SDG7</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG8.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">
                      Decent work and economic growth
                    </h5>
                    <p className="mb-0">SDG8</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-50 sm-mb-30">
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG10.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">Reduced inequalities</h5>
                    <p className="mb-0">SDG10</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG12.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">
                      Responsible consumption and production
                    </h5>
                    <p className="mb-0">SDG12</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG13.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">
                    Climate action
                    </h5>
                    <p className="mb-0">SDG13</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG16.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">
                      Peace, justice and strong institutions
                    </h5>
                    <p className="mb-0">SDG16</p>
                  </div>
                </div>
                <div
                  className="feature-text left-icon mt-40"
                  style={{ display: "flex" }}
                >
                  <div>
                    <img
                      src="/assets/images/RSE/SDG17.PNG"
                      alt
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="feature-info">
                    <h5 className="text-back">
                      Partnerships for the goals
                    </h5>
                    <p className="mb-0">SDG17</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="our-activities gray-bg page-section-ptb">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="section-title" style={{ paddingTop: "10%" }}>
                    <h6>Key figures for 2025</h6>
                    <h2 className="title-effect">
                      CSR performance in figures
                    </h2>
                  </div>
                </div>
                <div className="col-lg-5 sm-mt-50">
                  <div className="accordion shadow sm-mt-0">
                    <div className="acd-group">
                      <a
                        href="#"
                        className="acd-heading acd-active"
                        style={{ textTransform: "capitalize" }}
                      >
                        Gender pay gap{" "}
                      </a>
                      <div className="acd-des" style={{ display: "none" }}>
                        ✓ Equality achieved <br />✓ 0%
                      </div>
                    </div>
                    <div className="acd-group">
                      <a
                        href="#"
                        className="acd-heading"
                        style={{ textTransform: "capitalize" }}
                      >
                        Women in leadership roles
                      </a>
                      <div className="acd-des" style={{ display: "none" }}>
                        ↑ On the rise <br />
                        30%
                      </div>
                    </div>
                    <div className="acd-group">
                      <a
                        href="#"
                        className="acd-heading"
                        style={{ textTransform: "capitalize" }}
                      >
                        m³ of water consumed — Tinja site
                      </a>
                      <div className="acd-des" style={{ display: "none" }}>
                        3091 <br /> ⊙ Ongoing monitoring
                      </div>
                    </div>
                    <div className="acd-group acd-active">
                      <a
                        href="#"
                        className="acd-heading"
                        style={{ textTransform: "capitalize" }}
                      >
                        Members of the Board of Directors
                      </a>
                      <div className="acd-des" style={{}}>
                        7 <br /> 30 % women
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="container" style={{ paddingTop: "30px" }}>
            <div className="row">
              <div className="col-lg-7 col-md-7 align-self-end">
                <img
                  className="d-none d-md-block"
                  src="/assets/images/RSE/Global Compact_en.png"
                  alt="banner"
                  style={{ width: "652.5px", height: "509.89px" }}
                />
              </div>
              <div className="col-lg-5 col-md-5">
                <div
                  className="caption"
                  style={{ marginTop: "25%", textAlign: "center" }}
                >
                  <span className="off">Our commitment to the UN</span>
                  <h2>Member of the United Nations Global Compact</h2>
                  <p>
                    SACEM Industries reaffirms its support for the Ten Principles of the
                    Global Compact in the areas of human rights,
                    labour, the environment and the fight against
                    corruption.
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="container" style={{ paddingTop: "30px" }}>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className=" mb-30 clearfix" style={{ padding: "20px" }}>
                  <div className="clients-info sm-pt-20">
                    <h6 style={{ fontSize: 10 }}> Documentation</h6>
                    <h5>
                      2025 Progress Report — SACEM Industries
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6" style={{ display: "flex" }}>
                <div
                  className="col-lg-6 col-md-6"
                  style={{
                    display: "flex",
                    width: "50%",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="entry-button"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "50%",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <a
                        className="button button-border"
                        style={{ position: "relative", width: "260px" }}
                        href="/assets/brochures/SACEM_INDUSTRIES_CoP_Report_UN_Global_Compact_Tunisia_2026_EN.pdf"
                        download="SACEM_INDUSTRIES_CoP_Report_UN_Global_Compact_Tunisia_2026_EN.pdf"
                      >
                        ↓ Download CoP 2025
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-6"
                  style={{
                    display: "flex",
                    width: "50%",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="entry-button"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "50%",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <a
                        className="button button-border"
                        style={{ position: "relative", width: "155px" }}
                        href="https://unglobalcompact.org/what-is-gc/participants"
                      >
                        UN Profile →
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <div>
        <Footer_en />{" "}
      </div>
    </div>
  )
}

export default Durabilite_en